export const formatNumberShort = (value: number, decimalSeparator = '.') =>
  (value >= 1000000
    ? `${(value / 1000000).toFixed(2).replace(/\.?0+$/, '')}m`
    : value >= 1000
      ? `${(value / 1000).toFixed(2).replace(/\.?0+$/, '')}k`
      : value.toFixed(2).replace(/\.?0+$/, '')
  ).replace('.', decimalSeparator);
